export default __webpack_public_path__ + "static/blast-team-b4cbc76bd61447cb2e4cfce3751a06d2.png";